/* @ngInject */
export default function PumpsService($sails, $q, $log) {
  const vm = this;

  vm.getStatus = getStatus;
  vm.setSchedule = setSchedule;
  vm.getOptions = getOptions;
  vm.performAction = performAction;
  vm.processCurrentOption = processCurrentOption;

  /**
   * Gets the status of the panel from the server.
   *
   * @param {string} equipmentId id of the equipment
   * @returns {Promise<object>} Dial
   */
  function getStatus({ id }) {
    return $sails.get(`/equipment/${id}/statuses/getPumpStatuses`)
      .then(success => processCurrentOption(success.data.payload))
      .catch(catchError);
  }

  function processCurrentOption(values) {
    const dial = {};
    if (values.timer) {
      dial.currentOption = 'timer';
    } else if (values.modeLocalCloud) {
      dial.currentOption = values.cloudOffOn ? 'on' : 'off';
    } else {
      dial.currentOption = 'local';
    }

    dial.killSwitch = values.killSwitchOffOn;
    dial.schedule = values.timerSettings;
    dial.timeToWait = values.timeToWait;
    dial.status = values.pumpOffOn === 0 ? 'off' : 'on';
    return dial;
  }

  function setSchedule(id, schedule) {
    return $sails.post(`/equipment/${id}/actions/setSchedule/`, {
      schedule,
      id
    }).catch(catchError);
  }

  /**
   * Performs given action on given equipment
   *
   * @param {object} equipment
   * @param {string} equipment.id
   * @param {string} action API endpoint for the equipment
   * @returns {Promise}
   */
  function performAction({ id }, action) {
    return $sails.post(`/equipment/${id}/actions/${action}`, {
      id
    })
      .catch(catchError);
  }

  // Gets all options for pumps.  Action is what is accepted by performAction function.
  function getOptions() {
    return [{
      name: 'Local',
      value: 'local',
      action: 'setLocal'
    }, {
      name: 'Off',
      value: 'off',
      action: 'setCloudOff'
    }, {
      name: 'On',
      value: 'on',
      action: 'setCloudOn'
    }, {
      name: 'Timer',
      value: 'timer',
      action: 'setModeTimer'
    }];
  }

  // private functions
  function catchError(error) {
    $log.log('Error: ', error);
    return $q.reject(error.data);
  }
}
